import { Dispatch } from 'react';
import { request } from "./request";
import { SessionAction } from '../interfaces/Session';

export function getSettings(dispatch: Dispatch<SessionAction>) {
  return request(dispatch, '/control/settings', {
    method: 'GET',
    auth: false,
  });
}